import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import type { TeamMember } from '@api'
import { useQuery } from 'react-query'

import { teamService } from '@/modules/team/service/team-service.ts'
import { handleError } from '@/utils/error'

interface TeamActivityContextType {
  activityStates: TeamMember[] | undefined
  isLoading: boolean
}

const TeamActivityContext = createContext<TeamActivityContextType>({
  activityStates: undefined,
  isLoading: true,
})

export function useTeamActivityStates() {
  return useContext(TeamActivityContext)
}

export const TeamActivityProvider = ({ children }: PropsWithChildren) => {
  const {
    data: activityStates,
    isLoading,
    isIdle,
    refetch,
  } = useQuery('team-activity-states', () => teamService.getTeam(), {
    refetchInterval: 10000,
    onError: (error) =>
      handleError(error, 'Failed to get team activity states', refetch),
  })

  const value = {
    activityStates,
    isLoading: isLoading || isIdle,
  }

  return (
    <TeamActivityContext.Provider value={value}>
      {children}
    </TeamActivityContext.Provider>
  )
}
